import Vue from "vue";
import Component from 'vue-class-component';
import { modalHelper, IModalBase, DataItem, alertHelper, DataItemStatus } from '@/components';
import { Deferred } from '@/utils/Deferred';
import { areaSaggioClasseDiametricaStore } from '../store/areaSaggioClasseDiametrica.store';
import { Prop, Watch } from 'vue-property-decorator';
import { localizeFunction } from '@/filters/localizeFilter';
import { Async } from '@/utils/AsyncDecorators';
import { domainStore } from '@/modules/domains/store/domains.store';
import { toastHelper } from '@/helpers/ToastHelper';
import { Guid } from 'guid-typescript';
import { watch } from 'esri/core/watchUtils';
import { store } from '@/store';
import { onlineCheck } from "@/utils/onlineCheck";

@Component({})
export default class Form extends Vue {
  @Prop()
  value: {
    versioneId: string,
    areaSaggioId: string,
    specieArboree: number[],
    specieArboreePresenti: number[],
    classiDiametriche: number[],
    rilevamenti: server.areaSaggioClasseDiametrica[]
  };

  @Prop()
  deferred: Deferred<DataItem<server.areaSaggioClasseDiametrica[]>>;

  specieArboreeMax: number = 10;
  rangeClasseDiametrica: number = 100;
  get sogliaClasseDiametrica() {
    return (this.manage.diametroMin || 0) + this.rangeClasseDiametrica
  }

  get areaSaggioIdNavigationSelected() {
    return store.getters.navigation.selected("areaSaggio");
  }

  @Watch("areaSaggioIdNavigationSelected")
  changeAreaSaggioIdNavigationSelected(n, o) {
    if (n != o) this.back()
  }

  @Async({ async get() { return await (await domainStore.getters.specieArboree()) }, default: [], lazy: false })
  specieArboree: domains.domini[];

  get specieArboreeAreaSaggio(): domains.domini[] {
    const result: domains.domini[] = [];
    this.value.specieArboreePresenti.forEach(m => {
      const specie = this.specieArboree.find(f => f.id === m)
      if (specie) result.push(specie);
    })
    return result;
  }

  manage: { isNew: boolean, specieArboree: number[], diametroMin: number, diametroMax: number } = null
  mounted() {
    this.manage = {
      isNew: this.value.classiDiametriche.length <= 0,
      diametroMin: (this.value.classiDiametriche || []).length > 0 ? Math.min(...this.value.classiDiametriche) : 3,
      diametroMax: (this.value.classiDiametriche || []).length > 0 ? Math.max(...this.value.classiDiametriche) : 72,
      specieArboree: [...new Set(this.value.specieArboree)]
    }
    setTimeout(this.validateForm, 2000);
  }

  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }

  back() {
    this.deferred.resolve({ item: [], status: DataItemStatus.unchanged } as DataItem<server.areaSaggioClasseDiametrica[]>);
    modalHelper.closeModal("extended");
  }

  cancel: boolean = false;
  async remove() {
    const beforeDelete = await this.beforeDelete();
    if (beforeDelete)
      if (await alertHelper.show(localizeFunction('confirm-delete', `Sei sicuro di voler cancellare questo rilievo da cavallettamento?`))) {
        try {
          this.cancel = true;
          await areaSaggioClasseDiametricaStore.actions.removeAll({ versioneId: this.value.versioneId, areaSaggioId: this.value.areaSaggioId });
          this.deferred.resolve({ item: [], status: DataItemStatus.changed } as DataItem<server.areaSaggioClasseDiametrica[]>);
          modalHelper.closeModal("extended");
          this.cancel = false;
        } catch (e) {
          toastHelper.error('Impossibile cancellare il rilievo.')
        }
      }
  }

  async beforeDelete() {
    const needSync = await areaSaggioClasseDiametricaStore.getters.requiredSync();
    if (needSync) {
      toastHelper.error("Ci sono dei Rilievi da cavallettamento che necessitano di sincronia. Effettuare la sincronia prima di poter effettuare la cancellazione")
      return false;
    }

    const online = await onlineCheck()
    if (!online) {
      toastHelper.error("Non è possibile effettuare la cancellazione in modalità Offline")
      return false;
    }

    return !needSync && online;
  }

  async beforeSpecieArboreaDelete(specieArboreaId?: number): Promise<boolean> {
    var result = await areaSaggioClasseDiametricaStore.getters.getAll() || [];

    const filter = result.filter(f => f.areaSaggioId === this.value.areaSaggioId && (!specieArboreaId || specieArboreaId === f.specie));

    const needSync = filter.filter(s => s.__needsSync);

    if (needSync.length > 0 && needSync.length !== filter.length) {
      toastHelper.error("Ci sono dei Rilievi da cavallettamento che necessitano di sincronia. Effettuare la sincronia prima di poter effettuare la cancellazione")
      return false;
    }

    const online = await onlineCheck()
    if (!online && filter.some(s => !!s.timeStamp)) {
      toastHelper.error("Non è possibile effettuare la cancellazione in modalità Offline")
      return false;
    }

    return true;
  }

  saving: boolean = false;
  async ok() {
    if ((this.manage.specieArboree || []).length <= 0) {
      toastHelper.error("E' necessario inserire almeno una specie arborea!")
      return;
    }

    if (this.manage.diametroMin > this.manage.diametroMax) {
      toastHelper.error("Il diametro minimo non può essere maggiore del diametro massimo!")
      return;
    }

    const online = await onlineCheck();
    const diametroMin = (this.value.classiDiametriche || []).length > 0 ? Math.min(...this.value.classiDiametriche) : 3;
    const diametroMax = (this.value.classiDiametriche || []).length > 0 ? Math.max(...this.value.classiDiametriche) : 72;

    if (online) {
      this._okConfirm();
      return;
    }
    else {
      if (this.manage.isNew) {
        this._okConfirm();
        return;
      } else {
        if (diametroMin >= this.manage.diametroMin && diametroMax <= this.manage.diametroMax) {
          this._okConfirm();
          return;
        } else {
          if (await alertHelper.show(localizeFunction(
            'confirm-confirm-change',
            `Attenzione, in modalità Offline, non è possibile ridurre l'intervallo delle classi diametriche. Continuare il salvataggio con le classi diametriche precedenti?`))) {
            if (diametroMin < this.manage.diametroMin)
              this.manage.diametroMin = diametroMin;
            if (diametroMax > this.manage.diametroMax)
              this.manage.diametroMax = diametroMax;
            this._okConfirm();
            return;
          }
        }
      }
    }
  }
  private async _okConfirm() {
    this.saving = true;
    var toDelete = this.value.rilevamenti.filter(f => f.diametro < this.manage.diametroMin || f.diametro > this.manage.diametroMax || this.manage.specieArboree.indexOf(f.specie) === -1)
    if (toDelete.length > 0) {
      for (const key in toDelete) {
        const elem = toDelete[key];
        await areaSaggioClasseDiametricaStore.actions.remove(elem);
      }
    }

    const result: server.areaSaggioClasseDiametrica[] = [];
    for (let diametro = this.manage.diametroMin; diametro <= this.manage.diametroMax; diametro++) {
      for (let index = 0; index < this.manage.specieArboree.length; index++) {
        const specieArboreaId = this.manage.specieArboree[index];

        let cell = (this.value.rilevamenti || []).find(f =>
          f.versioneId === this.value.versioneId &&
          f.areaSaggioId === this.value.areaSaggioId &&
          f.specie === specieArboreaId &&
          f.diametro === diametro
        );

        if (!cell || (cell && cell.specieOrderIndex !== index)) {
          if (!cell) {
            cell = {
              id: Guid.create().toString(),
              versioneId: this.value.versioneId,
              areaSaggioId: this.value.areaSaggioId,
              specie: specieArboreaId,
              diametro: diametro,
              contatore: 0,
              specieOrderIndex: index
            } as server.areaSaggioClasseDiametrica;
          }
          cell.specieOrderIndex = index;
          await areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(cell);
        }
        result.push(cell);
      }
    }

    this.deferred.resolve({ item: result, status: DataItemStatus.changed } as DataItem<server.areaSaggioClasseDiametrica[]>);
    modalHelper.closeModal("extended");
    this.saving = false;
  }
}